import CanvassLogo from "/public/images/logos/CanvassMaster-logo.png";
import HighlevelLogo from "/public/images/logos/Highlevel-logo.png";
import SalesRabbitLogo from "/public/images/logos/SalesRabbit-logo.png";
import SpotioLogo from "/public/images/logos/Spotio-logo.png";

import { IntegrationFeature, IntegratorItem } from "components/ranked-table/types";

export enum CanvassingIntegrators {
  SPOTIO = "Spotio",
  GO_HIGH_LEVEL = "Go High Level",
  SALES_RABBIT = "Sales Rabbit",
  CANVASS = "Canvass",
}

const integrators: { [key: string]: IntegratorItem } = {
  [CanvassingIntegrators.SPOTIO]: {
    _id: CanvassingIntegrators.SPOTIO,
    name: CanvassingIntegrators.SPOTIO,
    logo: SpotioLogo,
    orderRank: "1",
  },
  [CanvassingIntegrators.GO_HIGH_LEVEL]: {
    _id: CanvassingIntegrators.GO_HIGH_LEVEL,
    name: CanvassingIntegrators.GO_HIGH_LEVEL,
    logo: HighlevelLogo,
    orderRank: "2",
  },
  [CanvassingIntegrators.SALES_RABBIT]: {
    _id: CanvassingIntegrators.SALES_RABBIT,
    name: CanvassingIntegrators.SALES_RABBIT,
    logo: SalesRabbitLogo,
    orderRank: "3",
  },
  [CanvassingIntegrators.CANVASS]: {
    _id: CanvassingIntegrators.CANVASS,
    name: CanvassingIntegrators.CANVASS,
    logo: CanvassLogo,
    orderRank: "4",
  },
};
export const defaultCanvassingAppsList = Object.values(integrators).sort(
  (a, b) => Number(a.orderRank) - Number(b.orderRank)
);

export const defaultCanvassingFeatures: IntegrationFeature[] = [
  {
    title: "Pass Lead details to Enerflo",
    integrators: [
      { item: { _ref: integrators[CanvassingIntegrators.SPOTIO]._id } },
      { item: { _ref: integrators[CanvassingIntegrators.GO_HIGH_LEVEL]._id } },
      { item: { _ref: integrators[CanvassingIntegrators.SALES_RABBIT]._id } },
      { item: { _ref: integrators[CanvassingIntegrators.CANVASS]._id }, detail: "Canvass Controlled" },
    ],
  },
  {
    title: "Create appointment through Webhook (opens new browser window from app)",
    integrators: [
      { item: { _ref: integrators[CanvassingIntegrators.SALES_RABBIT]._id } },
      { item: { _ref: integrators[CanvassingIntegrators.CANVASS]._id } },
    ],
  },
  {
    title: "Pass Appointment Details when Lead is pushed",
    integrators: [
      { item: { _ref: integrators[CanvassingIntegrators.SPOTIO]._id } },
      { item: { _ref: integrators[CanvassingIntegrators.GO_HIGH_LEVEL]._id } },
    ],
  },
  {
    title: "Change Lead Status in Enerflo when Lead is pushed",
    integrators: [
      { item: { _ref: integrators[CanvassingIntegrators.SPOTIO]._id } },
      { item: { _ref: integrators[CanvassingIntegrators.GO_HIGH_LEVEL]._id } },
      { item: { _ref: integrators[CanvassingIntegrators.SALES_RABBIT]._id } },
    ],
  },
  {
    title: "Change Lead Source in Enerflo when Lead is pushed",
    integrators: [
      { item: { _ref: integrators[CanvassingIntegrators.SPOTIO]._id } },
      { item: { _ref: integrators[CanvassingIntegrators.GO_HIGH_LEVEL]._id } },
      { item: { _ref: integrators[CanvassingIntegrators.SALES_RABBIT]._id } },
    ],
  },
  {
    title: "Push utility bill to Enerflo when Lead is pushed",
    integrators: [
      { item: { _ref: integrators[CanvassingIntegrators.SPOTIO]._id } },
      { item: { _ref: integrators[CanvassingIntegrators.GO_HIGH_LEVEL]._id }, detail: "Custom" },
      { item: { _ref: integrators[CanvassingIntegrators.SALES_RABBIT]._id }, detail: "Custom" },
    ],
  },
  {
    title: "Push files from Enerflo to External Application",
    integrators: [
      { item: { _ref: integrators[CanvassingIntegrators.SPOTIO]._id }, detail: "Custom" },
      { item: { _ref: integrators[CanvassingIntegrators.GO_HIGH_LEVEL]._id } },
    ],
  },
  {
    title: "Change Lead Status in External Application when progress is made on Lead in Enerflo",
    integrators: [
      { item: { _ref: integrators[CanvassingIntegrators.SPOTIO]._id }, detail: "Custom" },
      { item: { _ref: integrators[CanvassingIntegrators.GO_HIGH_LEVEL]._id }, detail: "Custom" },
      { item: { _ref: integrators[CanvassingIntegrators.SALES_RABBIT]._id }, detail: "Custom" },
    ],
  },
  {
    title: "Change Lead Source in External Application when progress is made on Lead in Enerflo",
    integrators: [
      { item: { _ref: integrators[CanvassingIntegrators.SPOTIO]._id }, detail: "Custom" },
      { item: { _ref: integrators[CanvassingIntegrators.GO_HIGH_LEVEL]._id }, detail: "Custom" },
      { item: { _ref: integrators[CanvassingIntegrators.SALES_RABBIT]._id }, detail: "Custom" },
    ],
  },
];
